import { render, staticRenderFns } from "./steps-collapsible.vue?vue&type=template&id=5b56799c&scoped=true"
import script from "./steps-collapsible.vue?vue&type=script&lang=ts"
export * from "./steps-collapsible.vue?vue&type=script&lang=ts"
import style0 from "./steps-collapsible.vue?vue&type=style&index=0&id=5b56799c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56799c",
  null
  
)

export default component.exports